import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge class names. Later classes win on Tailwind conflicts. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Identity helper for variant maps and base class strings.
 * Exists so `@shadcn/lint` can scan the classes (registered as a variant function)
 * and so the `as const` typing is preserved for `keyof typeof`.
 */
export function variants<const T extends string | Record<string, string>>(map: T): T {
  return map
}
